'use strict';

/**
 * handle warranty adition after ATC modal appear
 */
function handleATCModalWarranty() {
    /**
     * build warranty obtion json
     * @param {string} id optionId
     * @param {string} value optionId
     * @return {string} json onject
     */
    function getOptionsOnATCModelEmbeded(id, value) {
        var options = [{ optionId: id,
            selectedValueId: value }];

        return JSON.stringify(options);
    }

    /**
     * Updates the "Add to Cart" modal after "protect your purchase" action
     * @param {string} response - ajax response from clicking the "protect your purchase" button
     */
    function handlePostPurchaseAddEmbeded(response) {
        if (response.enableAddToCartModal) {
            $(
                '.redesign-atcmodal #addedToCartModal .line-item-total-price .price .sales .value'
            ).replaceWith(response.itemTotal);
            $('.redesign-atcmodal #addedToCartModal .line-item-option').replaceWith(
                response.optionDisplayName
            );
        }
    }

    /**
     * stop/finish button animation
     * @param {JQuery} self - reference to clicked button
     * @param {boolean} warrantAdded - is warranty added
     */
    function toggleOption(self, warrantAdded) {

        $('.warranty-add-button .added').hide();
        $('.warranty-add-button .add').show();
        $('.warranty-add-button').removeClass('warranty-added');

        if (warrantAdded) {
            self.find('.added').show();
            self.find('.add').hide();
            self.addClass('warranty-added');
        }
    }

    /**
     * disable/enable accept protection button (used for loading states)
     * @param {boolean} disabled - disable button
     */
    function toggleStateAcceptProtectionButton(disabled = true) {
        var acceptWarrantyButton = $('.product-protection-plan-button.accept');
        var warrantySpinner = $('.warranty-spinner');

        acceptWarrantyButton.prop('disabled', disabled);

        if (disabled) {
            warrantySpinner.removeClass('hidden');
        } else {
            warrantySpinner.addClass('hidden');
        }
    }

    /**
     * navigate to cart page
     * @param {boolean} startSpinner - start spinner
     */
    function navigateToCartPage(startSpinner = false) {
        if (startSpinner) {
            $.spinner().start();
        }
        window.location.href = $('.warranty-selection-buttons').attr('data-url');
    }

    /**
     * add selected warranty option
     * @param {JQuery} self - reference to clicked button
     */
    function addWarrantyOption(self) {
        var pid = $('.protect-your-purchase').attr('data-pid');
        var pliuuid = $('.protect-your-purchase').attr('data-pliuuid');
        var fromStoreId;
        var storeInventoryCount;

        fromStoreId = $('.protect-your-purchase').attr('data-pliFromStoreId');
        storeInventoryCount = $('.protect-your-purchase').attr('data-pliStoreInventoryCount');
        var protectYourPurchaseUrl = $('.protect-your-purchase').attr('data-protectyourpurchase-url');
        var optionId = self.attr('data-option-id');
        var optionValId = self.attr('data-value-id');
        var options = getOptionsOnATCModelEmbeded(optionId, optionValId);
        var form = {
            pid: pid,
            pliuuid: pliuuid,
            fromStoreId: fromStoreId,
            storeInventoryCount: storeInventoryCount,
            options: options
        };
        var warrantyPrice = self.parents('.radio-option-plan').find('.option-value .price').text();
        var warrantyData = {
            id: optionValId,
            name: self.parents('.radio-option-plan').find('.add.text-holder').text(),
            price: warrantyPrice && warrantyPrice.replace('$', ''),
            quantity: 1,
            variant: '',
            brand: '',
            category: optionId,
            dimension13: '',
            dimension14: '',
            dimension15: '',
            dimension16: '',
            dimension17: '',
            dimension19: ($('#product-detail-redesign') && $('#product-detail-redesign').attr('data-pid')) || window.lastAddedMasterProductId
        };
        if (protectYourPurchaseUrl) {
            toggleStateAcceptProtectionButton(true);
            $.spinner().start();

            $.ajax({
                url: protectYourPurchaseUrl,
                type: 'POST',
                data: form,
                dataType: 'json',
                success: function (successData) {
                    handlePostPurchaseAddEmbeded(successData);
                    $('body').trigger('product:warrantyATCEvent', { warrantyData: warrantyData, label: $('#product-detail-redesign') && $('#product-detail-redesign').length ? 'pdp' : 'plp' });
                    $('.warrantyPliUUID').val(successData.addedProductUUID);
                    navigateToCartPage();
                },
                error: function (errData) {
                    $.spinner().stop();
                }
            }).always(function () {
                toggleStateAcceptProtectionButton(false);
            });
        }
    }

    /**
     * get current checked option
     * @returns {JQuery} current checked option
     */
    function getCurrentCheckedOption() {
        var toggleWarrantyOption = $('.warranty-option-atcmodal');
        return toggleWarrantyOption.filter(function () {
            return $(this).attr('data-current-option') === 'true';
        });
    }

    $(document).ready(function () {
        var toggleWarrantyOption = $('.warranty-option-atcmodal');
        var acceptWarrantyButton = $('.product-protection-plan-button.accept');
        var declineWarrantyButton = $('.product-protection-plan-button.decline');
        var acceptWarrantyTooltip = $('#accept-tooltip');

        toggleWarrantyOption.click(function () {
            var self = $(this);
            var clickedCurrentOption = self.attr('data-current-option');
            var addWarranty = false;
            acceptWarrantyTooltip.addClass('hidden');

            if (clickedCurrentOption === 'true') {
                // option already selected - this is a remove option choice
                self.attr('data-current-option', 'false');
            } else {
                // this is to add warranty option
                toggleWarrantyOption.attr('data-current-option', 'false');
                self.attr('data-current-option', 'true');
                toggleWarrantyOption.removeClass('warranty-added');

                addWarranty = true;
            }

            toggleOption(self, addWarranty);
        });

        acceptWarrantyButton.click(function () {
            var isChecked = getCurrentCheckedOption().length === 1;
            acceptWarrantyTooltip.addClass('hidden');

            if (isChecked) {
                addWarrantyOption(getCurrentCheckedOption());
            } else {
                acceptWarrantyTooltip.removeClass('hidden');
            }
        });

        declineWarrantyButton.click(function () {
            acceptWarrantyTooltip.addClass('hidden');
            navigateToCartPage(true);
        });
    });
}

module.exports = {
    handleATCModalWarranty: handleATCModalWarranty
};
